/***
 *
 *   PRICING
 *   Phase 10 — page chrome around PricePlans.
 *
 **********/

import React from 'react';
import { Animate, PricePlans } from 'components/lib';
import { useTranslate } from 'app/translations';

export function Pricing(props) {
    const { _t } = useTranslate();

    return (
        <Animate type="pop">
            <section className="border-b border-border py-16 md:py-24">
                <div className="mx-auto max-w-6xl px-6">
                    <p className="mb-3 text-sm font-semibold uppercase tracking-wider text-accent-500">
                        {_t('pricing.label')}
                    </p>
                    <h1 className="mb-10 max-w-md text-2xl font-bold text-text-primary sm:text-3xl">
                        {_t('pricing.slogan')}
                    </h1>
                    <PricePlans />
                </div>
            </section>
        </Animate>
    );
}
